import { helper } from '@ember/component/helper';

export function isObject(params: unknown[]) {
  return typeof params?.[0] === 'object' && params?.[0] != null;
}

export default helper(isObject);
